<div id="FeedbackFile" class="modal modal-spaced-top fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header content-header">
                <button class="close close-btn" aria-label="Close" data-dismiss="modal" type="button" (click)="closeModel(); resetNote()">
                    <ds-icon name="close" size="inherit"></ds-icon>
                </button>
                <h4 *ngIf="!FromPreviewItinerary" class="modal-title">
                    {{ header }}
                    <span *ngIf="noteLoader">
                        <ds-loading-spinner theme="inherit" [diameter]="14" [strokeWidth]="2"></ds-loading-spinner
                    ></span>
                </h4>
                <h4 *ngIf="FromPreviewItinerary && fromPage == 'Perview'" class="modal-title">Customer Note</h4>
            </div>

            <div class="modal-body">
                <div class="member-card">
                    <div *ngIf="!FromPreviewItinerary && !isInternalReadOnly && fromPage !== 'Catering'" class="member-card card-layout">
                        <div>
                            <h4 class="filter-content-container row">
                                Filter Options
                                <button class="flat-butt flat-info-butt flat-info-grad-butt arrowButton" (click)="moreFilter = !moreFilter">
                                    <ds-icon name="arrow_downward" size="inherit"></ds-icon>
                                </button>
                            </h4>

                            <hr class="horizontal-line-style" />
                            <div *ngIf="moreFilter">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 mb-3">
                                        <div>
                                            <div>
                                                <label>Notes</label>
                                                <ng-multiselect-dropdown-angular7
                                                    [settings]="dropdownSettings"
                                                    [data]="categories"
                                                    [placeholder]="'Category'"
                                                    [(ngModel)]="filterCategory"
                                                >
                                                </ng-multiselect-dropdown-angular7>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-3 col-sm-3 col-xs-12 mt-2 pr-3">
                                        <div class="">
                                            <label class=""></label>
                                            <button
                                                id="close"
                                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 save-btn"
                                                style="font-size: 14px"
                                                type="submit"
                                                (click)="onApplySubmit()"
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-3 col-sm-3 col-xs-12 margin-top-5 pr-3">
                                        <div class="form-group">
                                            <label class=""></label>
                                            <button
                                                class="flat-butt flat-info-butt flat-info-grad-butt w-100 flat-danger-butt"
                                                style="font-size: 14px"
                                                type="button"
                                                (click)="cleanSearchedData()"
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!FromPreviewItinerary && fromPage != 'Perview'" class="d-flex" style="justify-content: space-between">
                        <h4>
                            Notes

                            <ds-icon
                                *ngIf="header != 'Notes' && !isInternalReadOnly"
                                name="add_circle"
                                size="inherit"
                                class="mr-2 cursorPointer text-color"
                                (click)="notesOpen = !notesOpen"
                            ></ds-icon>
                        </h4>
                    </div>
                    <div *ngIf="notesOpen">
                        <div *ngIf="!FromPreviewItinerary && fromPage != 'Perview'">
                            <div class="row">
                                <div *ngIf="fromPage !== 'Catering'" class="col-md-6">
                                    <div class="form-group">
                                        <label>Category<span class="text-danger">*</span></label>
                                        <select class="form-control" [(ngModel)]="selectedCategory">
                                            <option *ngFor="let category of categories" [value]="category.appCategoryId">
                                                {{ category.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Notes<span class="text-danger">*</span></label>
                                        <textarea
                                            class="form-control"
                                            maxlength="501"
                                            placeholder="Notes"
                                            [(ngModel)]="nodeFeedback"
                                            (ngModelChange)="noteSize($event)"
                                        ></textarea>
                                        <div *ngIf="display == true">
                                            <span style="color: red">Notes must not exceed 500 characters.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12" style="text-align: end">
                                    <button
                                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                                        (click)="isFieldShow = !isFieldShow; notesOpen = !notesOpen; resetNote()"
                                    >
                                        Cancel
                                    </button>
                                    <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" (click)="saveNoteFeedbackData()">
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 py-3">
                        Show
                        <select
                            class="margin-left-7 custom-select custom-select-sm grid-header-element number-sort-filter"
                            aria-controls="example1"
                            name="example1_length"
                            [(ngModel)]="recordsForList"
                            (change)="selectEntriesToShow()"
                        >
                            <option *ngFor="let number of numberOfEntries" [value]="number">
                                {{ number }}
                            </option>
                        </select>
                        entries
                    </div>
                    <div class="table-container">
                        <table id="jobid" class="table border-table mt-2 mb-0 card-layout">
                            <thead class="table-thead">
                                <tr>
                                    <td class="header_td table_heading">
                                        <div class="header_container text-primary">
                                            <!--<div class="header_title s_no">#</div>-->
                                            <div
                                                class="header_title width_10 cursorPointer"
                                                (click)="sortBy = 'createdOn'; sortOrder = !sortOrder; sortMe('date')"
                                            >
                                                Date
                                                <ds-icon
                                                    *ngIf="cDate == true"
                                                    name="expand_less"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                                <ds-icon
                                                    *ngIf="cDate == false"
                                                    name="expand_more"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                            </div>
                                            <div
                                                class="header_title width_10 cursorPointer"
                                                (click)="sortBy = 'createdBy'; sortOrder = !sortOrder; sortMe('by')"
                                            >
                                                By
                                                <ds-icon
                                                    *ngIf="by == true"
                                                    name="expand_less"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                                <ds-icon
                                                    *ngIf="by == false"
                                                    name="expand_more"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                            </div>
                                            <div
                                                *ngIf="!FromPreviewItinerary && fromPage != 'Perview' && fromPage !== 'Catering'"
                                                class="header_title width_10 cursorPointer"
                                                (click)="sortBy = 'noteCategory'; sortOrder = !sortOrder; sortMe('category')"
                                            >
                                                Category
                                                <ds-icon
                                                    *ngIf="category == true"
                                                    name="expand_less"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                                <ds-icon
                                                    *ngIf="category == false"
                                                    name="expand_more"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                            </div>
                                            <div
                                                class="header_title width_70 cursorPointer"
                                                (click)="sortBy = 'noteDescription'; sortOrder = !sortOrder; sortMe('mNotes')"
                                            >
                                                Note
                                                <ds-icon
                                                    *ngIf="mNotes == true"
                                                    name="expand_less"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                                <ds-icon
                                                    *ngIf="mNotes == false"
                                                    name="expand_more"
                                                    size="inherit"
                                                    class="margin-left-7"
                                                ></ds-icon>
                                            </div>
                                            <div *ngIf="user.role != 'Customer Admin'" class="header_title width_10">Action</div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="
                                        let note of mynotes
                                            | orderBy: sortBy : sortOrder : prioritySorting
                                            | paginate
                                                : {
                                                      itemsPerPage: recordsForList,
                                                      currentPage: currentPageForList,
                                                      totalItems: totalCount,
                                                      id: 'noteModel',
                                                  };
                                        let i = index
                                    "
                                >
                                    <td>
                                        <div
                                            class="row_container"
                                            [style.text-decoration]="note.isActive == true ? 'none' : 'line-through'"
                                        >
                                            <div class="title_container width_10">
                                                <div class="row_title">Date</div>
                                                <div class="row_detail">
                                                    {{ note.createdOn | localDate: timeZone }}
                                                </div>
                                            </div>
                                            <div class="title_container width_10">
                                                <div class="row_title">By</div>
                                                <div class="row_detail">
                                                    {{ note.createdBy }}
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="!FromPreviewItinerary && fromPage != 'Perview' && fromPage !== 'Catering'"
                                                class="title_container width_10"
                                            >
                                                <div class="row_title">Category</div>
                                                <div class="row_detail">
                                                    {{ note.noteCategory }}
                                                    <span *ngIf="isBadgeVisible">
                                                        <span *ngIf="note.level == 'Service Request Step'">
                                                            <span class="badge heading-font-size picked-Up-class"> Leg Note </span>
                                                            <span *ngIf="note.isDeleted == true" class="badge heading-font-size">
                                                                Deleted
                                                            </span>
                                                        </span>
                                                        <span *ngIf="note.level == 'Service Request'">
                                                            <span class="badge heading-font-size enroute-class"> SR Note </span>
                                                        </span>
                                                        <span *ngIf="note.level == 'Catering'">
                                                            <span class="badge heading-font-size on-scene-status-class">
                                                                Catering Note
                                                            </span>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="title_container width_70">
                                                <div class="row_title">Note</div>
                                                <div class="row_detail">
                                                    {{ note.noteDescription }}
                                                </div>
                                            </div>
                                            <div *ngIf="user.role != 'Customer Admin'" class="title_container width_10">
                                                <div class="row_title">Action</div>
                                                <div class="row_detail">
                                                    <button
                                                        class="flat-butt flat-danger-butt flat-danger-grad-butt delete-icon"
                                                        title="Delete Note"
                                                        type="button"
                                                        [disabled]="
                                                            note.isActive != true || isInternalReadOnly || deletingNoteIds.has(note.noteID)
                                                        "
                                                        [ngClass]="
                                                            note.isActive != true || isInternalReadOnly || deletingNoteIds.has(note.noteID)
                                                                ? 'cursorDisabled'
                                                                : ''
                                                        "
                                                        (click)="deleteNote(note)"
                                                    >
                                                        <ds-icon name="remove_circle" size="inherit"></ds-icon>
                                                    </button>
                                                    <button
                                                        class="flat-butt save-btn delete-icon"
                                                        title="Add Priority"
                                                        type="button"
                                                        *ngIf="note.isActive == true"
                                                        [disabled]="isInternalReadOnly"
                                                        [ngClass]="isInternalReadOnly ? 'cursorDisabled' : ''"
                                                        (click)="notePriority(note)"
                                                    >
                                                        <ds-icon
                                                            name="star"
                                                            size="inherit"
                                                            [ngClass]="{ notePriority: note.priority == null ? false : note.priority }"
                                                        ></ds-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="mynotes.length == 0" class="text-color ml-2 pt-3"><b>No Record Available</b></div>
                    </div>
                </div>
                <div class="d-flex">
                    <div *ngIf="mynotes.length > 0" class="col-md-6 col-sm-6 col-xs-5 pl-4">
                        {{ notesPagination }}
                    </div>
                    <div *ngIf="mynotes.length > 0" class="col-md-6 col-sm-6 col-xs-6 pagination text-end text-right pr-1">
                        <pagination-controls
                            id="noteModel"
                            [nextLabel]="R"
                            [previousLabel]="N"
                            [responsive]="responsive"
                            (pageChange)="currentPageForList = $event; currentPageChange()"
                        >
                        </pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
